module.exports = __webpack_public_path__ + "banquet/components/ShoppingCartPopover/images/nav_bag_highlight.38dd5043ba6fba05e45e2d8705955da4.svg";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/ShoppingCartPopover/images/nav_bag_highlight.svg
// module id = 1689
// module chunks = 1